
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface SopTaskGroup {
  id: string;
  name: string;
  area_id: string;
  brand_id: string;
  created_at: string;
  updated_at: string;
}

export const useSopTaskGroups = (brandId: string) => {
  return useQuery({
    queryKey: ["sop-task-groups", brandId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("sop_task_groups")
        .select("*")
        .eq("brand_id", brandId);

      if (error) throw error;
      return data as SopTaskGroup[];
    },
    enabled: !!brandId,
  });
};
